/**
 * Copyright (C) 2021 Prosperia Salud, S.A. DE C.V. info@prosperia.health.
 * All rights reserved
 * DO NOT REDISTRIBUTE
 * The software MAY NOT be rewritten or refactored by any means. The code MAY
 * NOT be packaged and redistributed by any means without prior written
 * permission from the author.
 */
import React, { createContext, useMemo, useState } from 'react';
/// /// INTERNAL /// ///
// hook //
import useSearch from 'hook/common/useSearch';

export const SearchContext = createContext();

export const SearchProvider = ({ children }) => {
  const [currentInteractions, setCurrentInteractions] = useState([]);
  const [channels, setChannels] = useState([]);

  const {
    searchChannels,
    setSearchChannels,
    searchFilters,
    updateFilters,
    searchDataGrid,
    updateDataGrid,
    cleanSearchDataGrid,
  } = useSearch();

  const context = useMemo(() => ({
    channels,
    setChannels,
    currentInteractions,
    setCurrentInteractions,
    searchChannels,
    setSearchChannels,
    searchFilters,
    updateFilters,
    searchDataGrid,
    updateDataGrid,
    cleanSearchDataGrid,
  }), [
    channels,
    setChannels,
    currentInteractions,
    setCurrentInteractions,
    searchChannels,
    setSearchChannels,
    searchFilters,
    updateFilters,
    searchDataGrid,
    updateDataGrid,
    cleanSearchDataGrid]);

  return (
    <SearchContext.Provider
      value={context}
    >
      {children}
    </SearchContext.Provider>
  );
};
